<template>
  <span class="manual-mode-button">
    <v-tooltip
      bottom
      :open-delay="500"
      :color="'rgba(0,0,0,0.8)'"
      :z-index="tooltipZIndex"
    >
      <template v-slot:activator="{ on, attrs }">
        <!-- обёртка нужна, чтобы подсказка показывалась и на задизейбленной кнопке -->
        <span class="d-block" v-bind="attrs" v-on="on">
          <large-btn
            class="primary-confirm-dialog_btn"
            :color="color"
            height="64px"
            :uppercase="false"
            :disabled="disabled"
            block
            @click="$emit('toggle')"
          >
            <v-icon
              v-if="!manual && manualIcon"
              class="mr-2"
              size="20"
              style="color: inherit"
            >
              {{ manualIcon }}
            </v-icon>
            <font-awesome-icon
              v-else
              :icon="manual ? 'credit-card' : 'hand-paper'"
              fixed-width
              class="mr-2"
            />
            <!-- обе подписи в одной ячейке: ширина кнопки не прыгает при переключении -->
            <span class="manual-mode-button_label">
              <span :class="{ 'manual-mode-button_hidden': manual }">Вручную</span>
              <span :class="{ 'manual-mode-button_hidden': !manual }">{{ autoLabel }}</span>
            </span>
          </large-btn>
        </span>
      </template>
      {{ manual ? autoHint : manualHint }}
    </v-tooltip>
  </span>
</template>

<script>
  import LargeBtn from '@/components/ui/buttons/LargeBtn.vue'

  export default {
    name: 'ManualModeButton',
    components: { LargeBtn },
    props: {
      manual: Boolean,
      disabled: Boolean,
      color: {
        type: String,
        default: '#f1f3f6',
      },
      autoLabel: {
        type: String,
        default: 'Терминал',
      },
      // MDI-иконка для «Вручную»; без неё - прежняя ладонь
      manualIcon: {
        type: String,
        default: null,
      },
      manualHint: {
        type: String,
        default: 'Провести оплату на терминале вручную',
      },
      autoHint: {
        type: String,
        default: 'Вернуться к оплате через терминал',
      },
    },
    data () {
      return {
        // подсказка должна всплывать над диалогом
        tooltipZIndex: 9999,
      }
    },
  }
</script>

<style lang="less" scoped>
.manual-mode-button {
  .v-btn {
    padding: 0 12px;
  }

  &_label {
    display: grid;

    // не grid-area: 1 / 1 — Less считает «/» делением
    > span {
      grid-row: 1;
      grid-column: 1;
    }
  }

  &_hidden {
    visibility: hidden;
  }
}
</style>
